/**
 * Canonical public site URL for share links and auth redirects.
 * Uses VITE_APP_BASE_URL when set; otherwise falls back to the current origin.
 */
export function getAppBaseUrl() {
  const configured = import.meta.env.VITE_APP_BASE_URL?.replace(/\/$/, '');
  if (configured) {
    return configured;
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'https://aokplay.com';
}
